var exports = {
  "f": "x0a7806d5--1b4113--column",
};

module.exports = exports;
